(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["enc-team"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.enc-team-carousel').forEach(function(carousel) {
  var id = carousel.getAttribute('data-id');
  var track = carousel.querySelector('.enc-team-track');
  var dotsWrap = carousel.querySelector('.enc-team-dots');
  var counter = carousel.querySelector('.enc-team-counter');
  var btnPrev = carousel.querySelector('.enc-team-btn-prev');
  var btnNext = carousel.querySelector('.enc-team-btn-next');
  if (!track) return;

  var slides = track.querySelectorAll('.enc-team-slide');
  var total = slides.length;
  var current = 0;

  slides.forEach(function(_, i) {
    var d = document.createElement('button');
    d.className = 'enc-team-dot' + (i === 0 ? ' is-active' : '');
    d.setAttribute('aria-label', 'Slide ' + (i + 1));
    d.addEventListener('click', function() { go(i); });
    dotsWrap.appendChild(d);
  });

  function go(n) {
    current = n;
    track.style.transform = 'translateX(-' + (current * 100) + '%)';
    dotsWrap.querySelectorAll('.enc-team-dot').forEach(function(d, i) {
      d.classList.toggle('is-active', i === current);
    });
    if (counter) counter.textContent = (current + 1) + ' / ' + total;
    btnPrev.disabled = current === 0;
    btnNext.disabled = current === total - 1;
  }

  btnPrev.addEventListener('click', function() { if (current > 0) go(current - 1); });
  btnNext.addEventListener('click', function() { if (current < total - 1) go(current + 1); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enc-timeline"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.enc-toggle').forEach(function (btn) {
    var previewId = btn.getAttribute('data-preview');
    var preview = document.getElementById(previewId);
    if (!preview) return;

    // Vérifie si le contenu déborde le line-clamp 2 lignes
    var isOverflowing = preview.scrollHeight > preview.clientHeight;

    if (isOverflowing) {
      // Débordement réel : on affiche le bouton
      btn.style.display = 'inline-flex';
    } else {
      // Tout tient en 2 lignes : on retire le clamp et on laisse le bouton masqué
      preview.style.display = 'block';
      preview.style.webkitLineClamp = 'unset';
      preview.style.overflow = 'visible';
    }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.enc-toggle');
    if (!btn) return;

    var previewId = btn.getAttribute('data-preview');
    var targetId = btn.getAttribute('data-target');
    var preview = document.getElementById(previewId);
    var more = document.getElementById(targetId);
    if (!preview || !more) return;

    var isOpen = more.classList.contains('is-open');

    if (isOpen) {
      // Fermeture : on réaffiche l'accroche, on masque le complet
      more.classList.remove('is-open');
      more.setAttribute('aria-hidden', 'true');
      preview.classList.remove('is-hidden');
      btn.setAttribute('aria-expanded', 'false');
      btn.querySelector('.enc-toggle-label').textContent = 'Lire plus';
    } else {
      // Ouverture : on masque l'accroche, on affiche le complet
      preview.classList.add('is-hidden');
      more.classList.add('is-open');
      more.setAttribute('aria-hidden', 'false');
      btn.setAttribute('aria-expanded', 'true');
      btn.querySelector('.enc-toggle-label').textContent = 'Réduire';
    }
  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text-right"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {

  document.querySelectorAll('.iwter-text-wrap').forEach(function(wrap) {
    var btn = document.querySelector('[data-target="' + wrap.id + '"]');
    if (!btn) return;

    var isOverflowing = wrap.scrollHeight > wrap.clientHeight;

    if (isOverflowing) {
      btn.style.display = 'inline-flex';
    } else {
      wrap.classList.add('is-open');
    }
  });

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.iwter-readmore');
    if (!btn) return;
    var wrap = document.getElementById(btn.getAttribute('data-target'));
    if (!wrap) return;
    var isOpen = wrap.classList.contains('is-open');
    wrap.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    btn.querySelector('.iwter-readmore-label').textContent = isOpen ? btn.dataset.labelMore : btn.dataset.labelLess;
  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {

  document.querySelectorAll('.iwte-text-wrap').forEach(function(wrap) {
    var btn = document.querySelector('[data-target="' + wrap.id + '"]');
    if (!btn) return;

    var isOverflowing = wrap.scrollHeight > wrap.clientHeight;

    if (isOverflowing) {
      btn.style.display = 'inline-flex';
    } else {
      wrap.classList.add('is-open');
    }
  });

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.iwte-readmore');
    if (!btn) return;
    var wrap = document.getElementById(btn.getAttribute('data-target'));
    if (!wrap) return;
    var isOpen = wrap.classList.contains('is-open');
    wrap.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    btn.querySelector('.iwte-readmore-label').textContent = isOpen ? btn.dataset.labelMore : btn.dataset.labelLess;
  });

});

  } catch(e) { console.error(e); }
})();
})();
